import React, { PureComponent } from 'react';

import { Loading } from 'components/cosmos';
import { inject, PropTypes as MobxPropTypes } from 'mobx-react';
import { FeatureToggles } from 'modules/featureToggle';
import PropTypes from 'prop-types';

import CampaignsService from './CampaignsService';
import { CampaignList } from './components/campaignList';
import { EmptyState } from './components/emptyState';

import { withFeatureToggle } from '../../../hoc/withFeatureToggle';

class Campaigns extends PureComponent {
  static propTypes = {
    list: MobxPropTypes.objectOrObservableObject,
    numberOfSales: MobxPropTypes.objectOrObservableObject,
    ids: MobxPropTypes.arrayOrObservableArray,
    loading: PropTypes.bool
  };

  componentDidMount() {
    CampaignsService.fetchCampaigns();
  }

  render() {
    const { ids, list, numberOfSales, loading } = this.props;

    if (loading) {
      return <Loading center />;
    }

    return (
      <div>
        {ids && ids.length > 0 ? (
          <CampaignList ids={ids} list={list} numberOfSales={numberOfSales} />
        ) : (
          <EmptyState />
        )}
      </div>
    );
  }
}

export default inject((stores) => ({
  list: stores.SalesStore.campaigns.list,
  ids: stores.SalesStore.campaigns.ids,
  numberOfSales: stores.SalesStore.campaigns.numberOfSales,
  loading: stores.SalesStore.campaigns.loading
}))(withFeatureToggle(Campaigns, FeatureToggles.SalesCampaignList));
export { Campaigns };
